import React, { useState, useEffect } from 'react'
import { CCard, CCardBody, CCol, CRow, CBadge } from 'compat/coreui'
import axios from 'axios';
import moment from 'moment';
import { txUrl } from '../../../chain/config';

const API = process.env.REACT_APP_APP_API_URL;
const authHeaders = () => ({ Authorization: 'Bearer ' + localStorage.getItem('token') });

// Payments ledger: every checkout that touched your shop, with the on-chain
// receipt where BRC was used. There are no paper invoices — the chain is the ledger.
export default function Invoice() {
  const [groups, setGroups] = useState([]);
  const [payments, setPayments] = useState({});   // groupId -> payment (lazy)

  useEffect(() => {
    axios.get(`${API}/api/order`, { headers: authHeaders() }).then(res => {
      const orders = res.data.orders || [];
      const byId = {};
      const out = [];
      for (const o of orders) {
        const key = o.orderGroupId || o._id;
        if (!byId[key]) { byId[key] = { key, groupId: o.orderGroupId, createdAt: o.createdAt, lines: [] }; out.push(byId[key]); }
        byId[key].lines.push(o);
      }
      setGroups(out);
      // fetch tx receipts for the BRC-paid groups (bounded)
      out.filter(g => g.groupId && g.lines[0].paymentMethod === 'BRC' && g.lines[0].paymentStatus === 'paid')
        .slice(0, 20)
        .forEach(g => {
          axios.get(`${API}/api/order/track/${g.groupId}`, { headers: authHeaders() }).then(r => {
            if (r.data.status && r.data.payment) setPayments(p => ({ ...p, [g.key]: r.data.payment }));
          }).catch(() => {});
        });
    }).catch(() => {});
  }, []);

  return (
    <>
      <CRow className="mb-3">
        <CCol>
          <h2 style={{ fontWeight: 800, marginBottom: 4 }}>Payments & Receipts</h2>
          <p className="text-muted">Every checkout on your shop. BRC payments carry a public on-chain receipt — the blockchain is the invoice.</p>
        </CCol>
      </CRow>
      {groups.length === 0 ? (
        <CCard>
          <CCardBody className="text-center" style={{ padding: '54px 20px' }}>
            <span style={{ fontSize: 40 }} aria-hidden="true">🧾</span>
            <h4 style={{ fontWeight: 800, margin: '12px 0 6px' }}>No payments yet</h4>
            <p className="text-muted" style={{ maxWidth: 440, margin: '0 auto' }}>
              When shoppers check out, each order appears here with its total, payment method, and on-chain receipt.
            </p>
          </CCardBody>
        </CCard>
      ) : (
        <CCard>
          <CCardBody>
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead>
                  <tr>
                    <th>Order</th>
                    <th>Date</th>
                    <th>Items</th>
                    <th>Total</th>
                    <th>Payment</th>
                    <th>Receipt</th>
                  </tr>
                </thead>
                <tbody>
                  {groups.map(g => {
                    const first = g.lines[0];
                    const total = g.lines.reduce((s, l) => s + (l.lineTotal || l.price * l.quantity || 0), 0);
                    const pay = payments[g.key];
                    return (
                      <tr key={g.key}>
                        <td className="bp-mono">#{String(g.key).slice(-8)}</td>
                        <td>{moment(g.createdAt).format('MMM D, YYYY')}</td>
                        <td>{g.lines.length}</td>
                        <td><strong>${total.toFixed(2)}</strong></td>
                        <td>
                          {first.paymentMethod === 'BRC'
                            ? <CBadge color={first.paymentStatus === 'paid' ? 'success' : 'warning'}>
                                {first.paymentStatus === 'paid' ? '⛓ BRC paid' : 'BRC pending'}
                              </CBadge>
                            : <CBadge color="info">Cash on delivery</CBadge>}
                        </td>
                        <td>
                          {pay && pay.txHash
                            ? <a href={txUrl(pay.txHash)} target="_blank" rel="noreferrer" className="bp-mono">
                                {pay.txHash.slice(0, 10)}… ↗
                              </a>
                            : <span className="text-muted">—</span>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      )}
    </>
  )
}
